<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    condition () {
      return this.$store.getters.condition
    }
  },
  methods: {
    getCondition (id) {
      this.$store.dispatch('getCondition', id)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getCondition(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Condition.vue?21f2f148